module.exports = __webpack_public_path__ + "img/安卓二维码.043bfeae.png";